import { call, put, takeLatest } from 'redux-saga/effects';

import * as url from '../../helpers/url_helper';

// Crypto Redux States
import { invoicesListTypes } from './actionTypes';
import { getInvoicesListSuccess, getInvoicesListFail, getMilestoneConfigINSuccess, getMilestoneConfigINFail } from './actions';
import { getMilestoneConfigOperation } from '../../helpers/GetMilestoneConfigOperation';

let controller = new AbortController();
let signal = controller.signal;

export const cancelFetchSO = () => {
  controller.abort(); 
  controller = new AbortController(); 
  signal = controller.signal;
};

export const fetchInvoicesList = async (data: any) => {
    const { from, to, order, dynamicFilter, dynamicFilterCF } = data.form;
    const { sizePerPage, page } = data.pagination;

    const path = url.API_URL;
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

    const query = `query {
    GetInvoiceList(Invoice: {
      userId: ${user.id || ''},
      initial_date: "${from || ''}",
      final_date: "${to + ' 11:59:00' || ''}",
      order : "${order}",
      ${dynamicFilterCF}
      ${dynamicFilter}
      }, Pagination:{
        sizePage:${sizePerPage},
        actualPage:${page}
      })
      {
        CountItems
        InvoiceData {
        id
        ClientId
        Number
        CreatedOn
        ExchangeRate
        DueDate
        Notes
        Status
        IsPrepaid
        IsPeriodic
        IsPrinted
        IsFiscalPrinted
        HasAttachments
        PaymentTerms
        GUID
        Type
        }
      }
    }`;
    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        signal,
        body: JSON.stringify({
            query,
        }),
    }).then((res) => res.json());
    return response.data.GetInvoiceList;
};


function* fetchinvoicesListSaga(data: any) {
    try {
        const response: Promise<any> = yield call(fetchInvoicesList, data.payload);
        yield put(getInvoicesListSuccess(response));
    } catch (error) {
        yield put(getInvoicesListFail(error));
    }
}

function* getMilestoneConfigIN(data: any): any {
  try {
    const response: Promise<any> = yield call(getMilestoneConfigOperation, {
      OperationType: "CR",
      ...data?.payload,
    });
    yield put(getMilestoneConfigINSuccess(response)); 
  } catch (error) {
    yield put(getMilestoneConfigINFail(error));
  }
}

function* invoicesListSaga() {
    yield takeLatest(invoicesListTypes.GET_INVOICES_LIST, fetchinvoicesListSaga);
    yield takeLatest(invoicesListTypes.GET_MILESTONESCONFIG_IN,getMilestoneConfigIN)
}

export default invoicesListSaga;
